import { Box, Button, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import AuthCard from "../AuthCard/AuthCard.wrapper";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormState } from "react-final-form";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { toast } from "react-toastify";

const ResetPassword = () => {

    const [newPassword, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const [error, setError] = useState('');

    const navigate = useNavigate();


    function useQueryParams() {
        const { search } = useLocation();
        return new URLSearchParams(search);
    }

    const query = useQueryParams();
    const email = query.get("email");
    const token = query.get("token");


    const resetPasswordMutation = useMutation({
        mutationFn: async (data :{email, token, newPassword}) => {
            console.log('ovde', data);
            const response = await axios.post('https://interviewer.runasp.net/api/users/reset-password', data);
            return response.data;
        },
        onSuccess: (data) => {
            toast.success('Password Changed Successfully!')
            navigate({
               to: '/login'
            })
        },
        onError: (error) =>  {
            setError(error.response.data.title);
            console.log('ne', error);
        }
    })

    const handleResetPassword = () => {

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }else{
            setError('');
            resetPasswordMutation.mutate({email, newPassword, token})
        }
    }

    return (
        <AuthCard>
            <Box sx={{pb: '16px'}}>
                <Typography variant="h1">Reset your password</Typography>
                <Typography sx={{pt: '8px'}} variant="h4">Please enter your new password below to complete the reset process.</Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <TextField 
                    label="Set new password" 
                    variant="outlined" 
                    fullWidth 
                    value={newPassword}
                    type={showPassword ? 'text' : 'password'}
                    onChange={(e) => setPassword(e.target.value)}
                    slotProps={{
                        input: {
                            endAdornment: (
                            <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowPassword((prev) => !prev)}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                            </InputAdornment>
                        ),
                        }
                    }}
                />
                <TextField 
                    label="Confirm password" 
                    variant="outlined" 
                    fullWidth 
                    value={confirmPassword}
                    type={showConfirmPassword ? 'text' : 'password'}
                    error={Boolean(error)}
                    helperText={error}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    slotProps={{
                        input: {
                            endAdornment: (
                            <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowConfirmPassword((prev) => !prev)}
                                edge="end"
                            >
                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                            </InputAdornment>
                        ),
                        }
                    }}
                />

            </Box>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleResetPassword}
                    fullWidth
                    disabled={resetPasswordMutation.isPending}
                >
                  Reset Password
                </Button>
        </AuthCard>
    )
}

export default ResetPassword;